(function () {
  'use strict';

  var nativeFetch = window.fetch;

  if (typeof nativeFetch !== 'function') {
    return;
  }

  window.fetch = function (input, options) {
    if (
      typeof input === 'string' &&
      input.indexOf('/recommendations/products?') === 0 &&
      window.theme &&
      window.theme.localeRootUrl
    ) {
      input = window.theme.localeRootUrl + input;
    }

    return nativeFetch.call(this, input, options);
  };
})();
